import React, { useContext } from "react";
import themeContext from "../../../../context/theme/ThemeContext";

const LibraryIcon = (props) => {
  const { themeName, getThemeColor,getThemeColorForTab} = useContext(themeContext);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
    >
      <path
        d="M3.8335 4.5H2.3335V15C2.3335 15.825 3.0085 16.5 3.8335 16.5H14.3335V15H3.8335V4.5ZM15.8335 1.5H6.8335C6.0085 1.5 5.3335 2.175 5.3335 3V12C5.3335 12.825 6.0085 13.5 6.8335 13.5H15.8335C16.6585 13.5 17.3335 12.825 17.3335 12V3C17.3335 2.175 16.6585 1.5 15.8335 1.5ZM13.5835 3V6.75L12.8335 6.1875L12.0835 6.75V3H13.5835ZM15.8335 12H6.8335V3H10.5835V9.75L12.8335 8.0625L15.0835 9.75V3H15.8335V12Z"
        // fill={themeName != "light"?props.active?"white":"#bfbfbf":getThemeColor("icon-color")}
        fill={getThemeColorForTab(props.active)}
      />
    </svg>
  );
};

export default LibraryIcon;
